import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { API } from "../App";
import { TrendingUp } from "lucide-react";
import DealCard from "./DealCard";
import { PRICING_DISCLAIMER } from "../lib/formatSpecial";

const FeaturedDeals = ({
  title = "Featured Deals Near You",
  subtitle = "Hand-picked apartments with the best value and move-in specials.",
  budgetMin,
  budgetMax,
  area,
  bedrooms,
  limit = 5,
  cta = "apply",
  deals: propDeals,
  bg = "bg-white",
}) => {
  const [deals, setDeals] = useState(propDeals || []);
  const [loading, setLoading] = useState(!propDeals);

  useEffect(() => {
    if (propDeals) { setDeals(propDeals); setLoading(false); return; }
    const params = new URLSearchParams();
    if (budgetMin) params.set("budget_min", budgetMin);
    if (budgetMax) params.set("budget_max", budgetMax);
    if (area) params.set("area", area);
    if (bedrooms) params.set("bedrooms", bedrooms);
    params.set("limit", limit);

    axios.get(`${API}/featured-deals?${params}`)
      .then((r) => setDeals(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [budgetMin, budgetMax, area, bedrooms, limit, propDeals]);

  if (loading) {
    return (
      <section className={`py-16 ${bg}`}>
        <div className="container-main flex justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0A2342]" />
        </div>
      </section>
    );
  }

  if (!deals.length) return null;

  return (
    <section className={`py-16 md:py-20 ${bg}`} data-testid="featured-deals-section">
      <div className="container-main">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-10">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#DE6E4B]/10 text-[#DE6E4B] rounded-full text-sm font-medium mb-4">
            <TrendingUp className="w-4 h-4" /> Top Picks
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-[#0A2342] font-['Playfair_Display'] mb-3" data-testid="featured-deals-title">
            {title}
          </h2>
          <p className="text-slate-500 max-w-lg mx-auto text-sm md:text-base">{subtitle}</p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {deals.slice(0, limit).map((deal, i) => (
            <DealCard key={deal.id || i} deal={deal} index={i} cta={cta} />
          ))}
        </div>
        <p className="mt-6 text-center text-xs text-slate-500" data-testid="pricing-disclaimer">{PRICING_DISCLAIMER}</p>
      </div>
    </section>
  );
};

export default FeaturedDeals;
